var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7875 1.73527C27.0224 1.04659 26.0294 0.665527 25 0.665527C23.9706 0.665527 22.9776 1.04659 22.2125 1.73527L0 21.7269V43.3936C0 45.1617 0.702379 46.8574 1.95262 48.1076C3.20286 49.3579 4.89856 50.0603 6.66667 50.0603H43.3333C45.1014 50.0603 46.7971 49.3579 48.0474 48.1076C49.2976 46.8574 50 45.1617 50 43.3936V21.7269L27.7875 1.73527ZM31.25 45.8873H18.75V35.4165C18.75 33.7589 19.4085 32.1692 20.5806 30.9971C21.7527 29.825 23.3424 29.1665 25 29.1665C26.6576 29.1665 28.2473 29.825 29.4194 30.9971C30.5915 32.1692 31.25 33.7589 31.25 35.4165V45.8873ZM45.8333 43.3873C45.8333 44.0504 45.5699 44.6863 45.1011 45.1551C44.6323 45.624 43.9964 45.8873 43.3333 45.8873H35.4167V35.4165C35.4167 32.6538 34.3192 30.0043 32.3657 28.0508C30.4122 26.0973 27.7627 24.9998 25 24.9998C22.2373 24.9998 19.5878 26.0973 17.6343 28.0508C15.6808 30.0043 14.5833 32.6538 14.5833 35.4165V45.8873H6.66667C6.00363 45.8873 5.36774 45.624 4.8989 45.1551C4.43006 44.6863 4.16667 44.0504 4.16667 43.3873V23.5811L25 4.8311L45.8333 23.5811V43.3873Z",
    fill: "#2942FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home-blue.50a27c96e1320e1a238b612e3b0aa1bf.svg";
export { ForwardRef as ReactComponent };